<order-collapse [date]="getDate(order?.createdAt)" [number]="order?.code" [type]="type" [totalPrice]="order?.totalPrice">
  <ng-container *ngFor="let product of order?.entries">
    <cart-product [entry]="product" [disabled]="true" [hideQuantity]="true" [onCheckout]="false" />
  </ng-container>
</order-collapse>

@if (order?.isQuotation && order?.quotationExpiresAt) {
  <div
    class="quotation-expires-badge mt-2 px-2 py-1 d-inline-flex align-items-center gap-1 border rounded bg-warning-subtle text-warning-emphasis small"
  >
    <span class="material-symbols-outlined" style="font-size: 16px">schedule</span>
    <span>{{ 'order.quotationExpiresAt' | translate }}: {{ getDate(order?.quotationExpiresAt) }}</span>
  </div>
}
